module.exports = __webpack_public_path__ + "media/health/treatment-icon-452b0270.svg";